import { MultiStepForm, UserProfileModel } from '@nw/fields-manager';
import { GetProductDetailsResponseType } from '@nw/shared/data-access';

import { BaseProductDetail } from './BaseProductDetail';
import { DefaultPricingDetails } from './DefaultPricingDetails';

export class DefaultProductDetail extends BaseProductDetail {
  readonly pricingType = 'FULL_PAYMENT';
  readonly initialPricingDetails: DefaultPricingDetails;
  currentPricingDetails: DefaultPricingDetails;

  constructor(
    productDetails: GetProductDetailsResponseType,
    userProfileDetails: UserProfileModel | null = null
  ) {
    super(productDetails);

    this.initialPricingDetails = new DefaultPricingDetails(productDetails);
    this.currentPricingDetails = this.initialPricingDetails;
    this.form = this.parsedUserExtraInfoConfig
      ? new MultiStepForm(
          this.parsedUserExtraInfoConfig.registration_form_details,
          userProfileDetails,
          this
        )
      : undefined;
  }

  shouldShowCouponApplyButton(): boolean {
    return (
      this.currentPricingDetails.amountToBePaid > 0 &&
      (this.parsedExtraData?.should_show_coupon_apply_button ?? true)
    );
  }

  updateCurrentDetailsWithReferralCodeResponse(
    pricingDetailsObject: DefaultPricingDetails
  ) {
    this.currentPricingDetails = pricingDetailsObject;
  }

  updateCurrentDetailsWithInitialPricingDetails() {
    this.currentPricingDetails = this.initialPricingDetails;
  }
}
